import type { DeepKeys } from "@tanstack/table-core";

import { CompetencyFit } from "@/types/screeners";

export interface PaginationMeta {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export interface BaseTableQueryParams {
  page: number;
  search: string;
  sortBy: string;
  sortOrder: SortOrder;
}

export const BaseTableQueryKeys = {
  page: "page",
  search: "search",
  sortBy: "sortBy",
  sortOrder: "sortOrder",
} as const satisfies { [K in keyof BaseTableQueryParams]: K };

export interface CreatedAtQueryParams {
  createdAtAfter: Date;
  createdAtBefore: Date;
}

export const CreatedAtQueryKeys = {
  createdAtAfter: "createdAtAfter",
  createdAtBefore: "createdAtBefore",
} as const satisfies { [K in keyof CreatedAtQueryParams]: K };

export type FilterableCompetencyFits =
  | CompetencyFit.Medium
  | CompetencyFit.High
  | CompetencyFit.VeryHigh;

// column type definition from backend/api
export type ApiColumn<Model> = {
  fieldName: DeepKeys<Model>;
  internalName: string;
  type: string;
};

export interface DataDumpResponse {
  candidateEmails: string[];
  page: string;
  screenerLocationIds: string[];
  uuid: string;
}
